import { Box } from '@mantine/core'
import dayjs from 'dayjs'

import { navigate, routes } from '@redwoodjs/router'

import { buildFullName } from 'src/lib/formatters'
import { decodeHtmlEntities } from 'src/lib/string-util'

const EmailCard = ({ email, onClick = null }) => {
  return (
    <Box
      className="flex w-full cursor-pointer flex-row items-center gap-2 rounded p-2 text-xs hover:bg-doubleNickel-gray-50"
      onClick={() => {
        if (onClick) {
          onClick()
        } else {
          navigate(routes.emailsWithId({ id: email.emailThreadId }))
        }
      }}
    >
      <div className="flex w-full flex-col gap-1">
        <div className="flex w-full flex-row items-center justify-between">
          <div className="w-[60%] truncate text-sm font-medium">
            {email?.applicant
              ? buildFullName(email.applicant)
              : email.emails[0].to.join(', ')}
          </div>
          <div className="text-xs text-doubleNickel-gray-500">
            {dayjs(email.lastDate).format('MM/DD/YYYY')}
          </div>
        </div>
        <div className="text-xs font-medium">
          {decodeHtmlEntities(email.lastSubject)}
        </div>
        <div className="line-clamp-3 text-xs text-doubleNickel-gray-500">
          {decodeHtmlEntities(email.lastSnippet)}
        </div>
      </div>
    </Box>
  )
}

export default EmailCard
